export enum SubnetForms {
  Fabric = "Fabric",
  VLAN = "VLAN",
  Space = "Space",
  Subnet = "Subnet",
}

export enum SubnetsUrlParams {
  By = "by",
  Q = "q",
}
